import { MutationTree } from "vuex";
import { PROVEED } from "./types";

type ProveedoresMutationTree = MutationTree<PROVEED>;

export const mutations: ProveedoresMutationTree = {};
